import React from 'react';
import { COVID_19_NEWS } from './variables';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import PapersIcon from '../../images/features/ana/papers.png';
import { lighten, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  link: {
    color: '#004AD6',
    textDecoration: 'underline',
    '&:hover': {
      color: lighten('#004AD6', 0.4),
    },
  },
}));

const Link = ({ href, children, className, ...rest }) => {
  const classes = useStyles();
  return (
    <a href={href} className={clsx(classes.link, className)} {...rest}>
      {children}
    </a>
  );
};

export const Covid19Link = withStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      marginTop: 15,
    },
    '& > span': {
      textDecoration: 'underline',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'inline-block',
      },
    },
  },
}))(({ classes }) => (
  <div style={{ textAlign: 'center' }}>
    <Link href={COVID_19_NEWS} className={classes.root}>
      <span>新型コロナウイルス</span>
      <span>感染予防対策に関して</span>
    </Link>
  </div>
));

export const Covid19Button = withStyles((theme) => ({
  root: {
    height: 60,
    margin: '12px 0',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#0B318F',
    '&:hover': {
      color: 'white',
      backgroundColor: '#2E75B1',
    },
  },
  label: {
    '&:hover': {
      color: 'white',
    },
  },
  startIcon: {
    '& img': {
      width: 50,
      height: 36.38,
    },
  },
}))(({ classes }) => (
  <Button
    fullWidth
    classes={classes}
    variant="contained"
    href={COVID_19_NEWS}
    startIcon={<img src={PapersIcon} alt="papers_icon" />}
  >
    <div>
      <span className="d-inline-block">新型コロナウイルス感染予防</span>
      <span className="d-inline-block">のための</span>
      <span className="d-inline-block">ご協力のお願い</span>
    </div>
  </Button>
));
